import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalSettingsService } from 'src/app/_Common/_Services/global-settings.service';
import { UserService } from 'src/app/_Common/_Services/user.service';
import { catchError } from 'rxjs/operators';

@Injectable({providedIn: "root"})
export class UploaderService {

  constructor(private globalSettings: GlobalSettingsService,
    private http: HttpClient,
    private userService: UserService) {

  }

  uploadFile(postObj): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', postObj.uploadFile, postObj.uploadFile.name);
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/import/uploadActionExcel', formData)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)))
  }

  uploadImgProof(postObj): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', postObj.file, postObj.file?.name);
    formData.append('CommunicationDetailId', postObj.data.CommunicationDetailId);
    formData.append('DueId', postObj.data.DueId);
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/timeline3/addFileCommDetail', formData)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)))
  }

  removeImgProof(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/timeline3/removeFileCommDetail', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)))
  }

}
